export const selectMetrics = (state) => state.metrics;
export const selectToast = (state) => state.toast;
export const selectSession = (state) => state.session;
export const selectConfig = (state) => state.config;
export const selectNavigation = (state) => state.navigation;
export const selectReferral = (state) => state.referral;
export const selectPromoter = (state) => state.promoter;